import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Monogram } from "@/components/layout/Header";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-lg border border-white/10 bg-coal/60 p-10">
        <div className="flex flex-col items-center">
          <Monogram className="h-12 w-12" />
          <h1 className="mt-6 text-sm font-bold tracking-[0.3em] text-ivory">PALAIS MAASAÏ</h1>
          <p className="mt-2 text-xs uppercase tracking-[0.2em] text-ivory/40">Administration</p>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="admin-login-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="input-dark"
            data-testid="admin-email-input"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            className="input-dark"
            data-testid="admin-password-input"
          />
          {error && (
            <p className="text-sm text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="admin-login-submit"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
